import { ClientTerm } from 'api/leader'

export type PreviewTerm = ClientTerm & {
  index: number
  preChecked: boolean
}

// The preview shows the form that a fan in the US sees, so the US pre-select setting always applies.
export function toPreviewTerms(terms: ClientTerm[] = []): PreviewTerm[] {
  return terms.map((term, index) => ({ ...term, index, preChecked: Boolean(term.checkedByDefault) }))
}
